module.exports = __webpack_public_path__ + "img/sigefLogin.4530d1ca.png";